import React from "react";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { Reveal } from "./Motion";
import {
  PHONE_TEL,
  PHONE_DISPLAY,
  WHATSAPP_URL,
  EMAIL,
  ASSETS,
} from "../data/site";

const Row = ({ icon: Icon, label, value, testId, href }) => {
  const content = (
    <>
      <span className="w-11 h-11 flex items-center justify-center border border-white/10 bg-[#050505] text-[#e60000] shrink-0">
        <Icon size={20} />
      </span>
      <span className="flex flex-col">
        <span className="font-mono-tech text-[11px] tracking-widest text-neutral-500 uppercase">
          {label}
        </span>
        <span className="text-white text-base md:text-lg font-medium">{value}</span>
      </span>
    </>
  );
  return href ? (
    <a
      data-testid={testId}
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel="noopener noreferrer"
      className="flex items-center gap-4 hover:opacity-80 transition-opacity"
    >
      {content}
    </a>
  ) : (
    <div data-testid={testId} className="flex items-center gap-4">
      {content}
    </div>
  );
};

export const Contact = () => (
  <section
    id="contato"
    data-testid="contact-section"
    className="relative bg-[#0a0a0a] py-20 md:py-28 overflow-hidden grain"
  >
    <div
      className="absolute inset-0 opacity-10"
      style={{
        backgroundImage: `url(${ASSETS.nightRoad})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0a0a0a]/90 to-[#0a0a0a]" />

    <div className="max-w-[1400px] mx-auto px-4 md:px-10 relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
          / Fale conosco
        </span>
        <h2 className="mt-4 font-display font-bold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
          Precisa de um Guincho?
        </h2>
        <p className="mt-4 text-neutral-400 text-lg">
          Fale agora com a FS Guinchos.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            data-testid="contact-call-btn"
            href={PHONE_TEL}
            className="flex-1 flex items-center justify-center gap-3 bg-[#e60000] hover:bg-[#b30000] text-white px-8 py-5 font-bold uppercase tracking-wide transition-colors red-glow"
          >
            <Phone size={22} />
            Ligar Agora
          </a>
          <a
            data-testid="contact-whatsapp-btn"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#1eb85a] text-black px-8 py-5 font-bold uppercase tracking-wide transition-colors wa-glow"
          >
            <MessageCircle size={22} />
            Chamar no WhatsApp
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="bg-[#121212] border border-white/10 p-8 md:p-10 space-y-7">
          <Row
            icon={Phone}
            label="Telefone"
            value={PHONE_DISPLAY}
            testId="contact-phone"
            href={PHONE_TEL}
          />
          <Row
            icon={MessageCircle}
            label="WhatsApp"
            value={PHONE_DISPLAY}
            testId="contact-wa"
            href={WHATSAPP_URL}
          />
          <Row
            icon={Mail}
            label="E-mail"
            value={EMAIL}
            testId="contact-email"
            href={`mailto:${EMAIL}`}
          />
          <Row
            icon={MapPin}
            label="Área de atendimento"
            value="Porto Alegre, Região Metropolitana e outras localidades."
            testId="contact-area"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
